import { ElectricStatus } from '../constants/ElectricStatus';

export default {
    "model": {
        "status": {
            type: "list",
            format: [ElectricStatus.ENERGIZED, ElectricStatus.DEENERGIZED],
            default: ElectricStatus.DEENERGIZED,
            bind: {
                to: "attr",
                name: "data-status"
            }
        }
    },
    listeners: {
        click: true,
        contextmenu: true,
        mouseenter: true,
        mouseleave: true,
    }
}